export default class PoisonBaitInfoPage {
    constructor(number=0, baitType, baitOther, lat, lng, codeAnalysis) {
        this.number = number;
        this.baitType = baitType;
        this.baitOther = baitOther;
        this.lat = lat;
        this.lng = lng;
        this.codeAnalysis = codeAnalysis;
    }
}